
import React from "react";

export default function Footer() {
  return (

    <footer className="main-footer text-center">
  © 2025 <strong>Amrita CREATE</strong> | AI Video Accessibility Platform

  {/* <style jsx>{`
    .main-footer {
      width: 100%;
      padding: 6px 0;
      font-size: 14px;
      color: #2b2f36;
      border-top: 1px solid #e5e5e5;
      background: #fff;
    }

    strong {
      color: #2b2f36;
    }
  `}</style> */}
</footer>

  );
}
